import React from 'react';
import { Box, Tooltip, Typography, Divider } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import ConstructionIcon from '@mui/icons-material/Construction';
import LayersIcon from '@mui/icons-material/Layers';
import ShareIcon from '@mui/icons-material/Share';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useWorkspace } from './WorkspaceContext.js';
import { SIDEBAR_WIDTH } from './workspaceConstants.js';

export const MENUS = [
  { id: 'buildings', label: 'Gebäude', Icon: ApartmentIcon },
  { id: 'scenarios', label: 'Szenarios', Icon: ThunderstormIcon },
  { id: 'actions', label: 'Maßnahmen', Icon: ConstructionIcon },
  { id: 'view', label: 'Ansicht', Icon: LayersIcon },
  { id: 'share', label: 'Freigabe', Icon: ShareIcon },
];

const itemStyle = (selected) => ({
  width: '100%',
  py: 1.25,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0.25,
  cursor: 'pointer',
  userSelect: 'none',
  color: selected ? '#0b4f77' : '#37474f',
  backgroundColor: selected ? '#d7ecf9' : 'transparent',
  borderLeft: selected ? '3px solid #1976d2' : '3px solid transparent',
  transition: 'background-color 0.15s',
  '&:hover': { backgroundColor: selected ? '#d7ecf9' : '#eceff1' },
});

const labelStyle = {
  fontSize: '11px',
  lineHeight: 1.2,
  textAlign: 'center',
  px: 0.5,
  color: 'inherit',
};

const WorkspaceSidebar = () => {
  const { openMenu, toggleMenu } = useWorkspace();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
        flexShrink: 0,
        backgroundColor: '#fafafa',
        borderRight: '1px solid #cfd8dc',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        zIndex: 1200,
      }}
    >
      {MENUS.map(({ id, label, Icon }) => (
        <Box key={id} sx={itemStyle(openMenu === id)} onClick={() => toggleMenu(id)}>
          <Icon fontSize="medium" />
          <Typography sx={labelStyle}>{label}</Typography>
        </Box>
      ))}

      <Box sx={{ flexGrow: 1 }} />
      <Divider />
      <Tooltip title="Zurück zur Regionenauswahl" placement="right">
        <Box sx={itemStyle(false)} onClick={() => navigate('/')}>
          <ArrowBackIcon fontSize="medium" />
          <Typography sx={labelStyle}>Regionen&shy;auswahl</Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default WorkspaceSidebar;
